<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/cylinders/_form.vue';
import StoreForm from "@wielink-application/shared/js/mixins/storeForm";
import {router} from "@inertiajs/vue3";

export default {
  mixins: [StoreForm],
  components: {App, Form},
  data() {
    return {
      formRoute: route('api.v1.cylinders.store'),
      redirectRoute: route('cylinders.index'),
      stayOnPageRedirect: route('cylinders.edit', {cylinder: '_id_'}),
      addNew: false
    }
  },
}
</script>

<template>
  <App title="Cilinder toevoegen">
    <form id="cylinderForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          form-id="cylinderForm"
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          :cancel-route="redirectRoute"
      >
        <button @click="stayOnPageRedirect = route('cylinders.create', {'success': 'Ok'})" form="cylinderForm" :class="{'btn btn-primary': true, 'loading' : loading}" :disabled="loading">
          Opslaan en nieuwe toevoegen
        </button>
      </FormButtons>
    </template>
  </App>
</template>